module.exports = __webpack_public_path__ + "blank-bg-3b8b242b0ffae9017e15472bf2c2c391.png";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/components/image_generator/blank-bg.png
// module id = 100
// module chunks = 0 1